module.exports = __webpack_public_path__ + "img/gauge-simple-max.63a50832.svg";